import React from "react";
import {
  useTable,
  // useFilters,
  // useGlobalFilter,
  // useAsyncDebounce,
  // useSortBy,
  // usePagination,
} from "react-table";

import VerticalSpace from "../VerticalSpace";

import "./tablestyle.sass";

const Table = ({ columns, data, classs, hasSpace }) => {
  // Use the state and functions returned from useTable to build UI
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable(
      {
        columns,
        data,
      }
      // useFilters, // useFilters!
      // useGlobalFilter,
      // useSortBy,
      // usePagination // new
    );

  // Render the UI for table
  return (
    <>
      {/* table */}
      <div className='flex flex-col font-10 sm:text-xs md:text-sm w-full'>
        <div className='-my-2 overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8'>
          <div className='py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8'>
            <div className='overflow-hidden'>
              {hasSpace && <VerticalSpace space='1rem' />}

              <table {...getTableProps()} className={`min-w-full ${classs}`}>
                <thead className=''>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        // Add the sorting props to control sorting. For this example
                        // we can add them into the header props
                        <th
                          scope='col'
                          className='group p-2  font-semibold'
                          {...column
                            .getHeaderProps
                            // column.getSortByToggleProps()
                            ()}
                        >
                          <div className='flex items-center justify-center text-center'>
                            {column.render("Header")}
                            {/* Add a sort direction indicator */}
                            {/* <span>
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <SortDownIcon className='w-4 h-4 text-gray-400' />
                                ) : (
                                  <SortUpIcon className='w-4 h-4 text-gray-400' />
                                )
                              ) : (
                                <SortIcon className='w-4 h-4 text-gray-400 opacity-0 group-hover:opacity-100' />
                              )}
                            </span> */}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <VerticalSpace space='1rem' />

                <tbody {...getTableBodyProps()} className='bg-white w-full'>
                  {rows.map((row, i) => {
                    // new
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className='px-4 py-3 '
                              role='cell'
                            >
                              {cell.column.Cell.name === "defaultRenderer" ? (
                                <div className=''>{cell.render("Cell")}</div>
                              ) : (
                                cell.render("Cell")
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Table;
